module.exports = __webpack_public_path__ + "38e48fca61e5a793f139026254e69a53.pdf";